jQuery.fn.extend({
	autoHeight:function(params){
        var items = $(this);
        $(window).on('media.pageStateInit', function(e, state){
            if(state.bootstrapGrid >= 768){
                items.each(function(i,el){
                    var maxHeight = $(el).height();
                    var target = $(el).find(params.target);
                    var text = target.text();
                    target.hide();
                    var minHeight = $(el).height();
                    target.show();
                    if(minHeight < maxHeight){
                        text = text.trim().replace(/\s+/giu,' ');
                        var newtext = text;
                        do{
                            text = newtext;
                            newtext = text.replace(/(\s)\S+$/giu,'');
                            target.text(newtext + ' ...');
                            var curHeight = $(el).height();
                        } while( (newtext != text) && (curHeight > minHeight) );
                    }
                })
            }
        });
    },
    maxRows: function(rows){
        var items = $(this);
          $(window).on('media.pageStateInit', function(e, state){
              if(state.bootstrapGrid >= 768){
                    items.each(function(i,el){
                        var maxHeight = $(el).height();
                        var minHeight = parseInt($(el).css('line-height')) * rows;
                        if(minHeight < maxHeight){
                            var originalText = $(el).text();
                            var text = originalText.trim().replace(/\s+/giu,' ');
                            var newtext = text;
                            do{
                                text = newtext;
                                newtext = text.replace(/(\s)\S+$/giu,'');
                                $(el).text(newtext + ' ...');
                                var curHeight = $(el).height();
                            } while( (newtext != text) && (curHeight > minHeight) );
                            $(el).tooltip({
                                trigger: 'hover',
                                title: originalText
                            });
                        }
                    });
              }
          });
    }
});

